import React from 'react'
import Slider from "react-slick";

export default function ServiceIndia() {
    const settingskey = {
        autoplay: true,
        speed: 5000,
        autoplaySpeed: 5000,
        infinite: true,
        arrows: false,
        dots: true,
        pauseOnHover: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                },
            },

            {
                breakpoint: 99999,
                settings: "unslick",
            },
        ],
    };

    return (
        <>
        <section className="servicearea-india">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-7">
                        <h4 className='heading center-heading'>Service And Support Where Your Facility Operates</h4>
                    </div>

                    <div className="col-lg-12">
                        <Slider {...settingskey} className="serviceindia-slider">
                            <div className="serviceindia-box">
                                <img src="/assets/images/service-india-1.webp" alt="Service" className="img-responsive" loading="lazy" />
                                <span>North And Central India</span>
                                <p>Delhi NCR and surrounding regions covered by dedicated service teams with fast response times and stocked parts for all major equipment types.</p>
                            </div>

                            <div className="serviceindia-box">
                                <img src="/assets/images/service-india-2.webp" alt="Service" className="img-responsive" loading="lazy" />
                                <span>West & South India</span>
                                <p>Active presence across major cities with experienced installation and service engineers handling everything from commissioning to emergency repairs.</p>
                            </div>

                            <div className="serviceindia-box">
                                <img src="/assets/images/service-india-3.webp" alt="Service" className="img-responsive" loading="lazy" />
                                <span>Nationwide Support</span>
                                <p>Facilities outside primary zones are covered through our national logistics and service network ensuring parts, technical support, and planned maintenance reach you without extended delays.</p>
                            </div>
                        </Slider>
                    </div>

                </div>
            </div>
        </section>
        </>
    )
}
